customElements.define(

  "cc-subscribe-form", 

  class extends HTMLElement{

    connectedCallback(){

        this.innerHTML = `

            <div class="cc-subscribe-form">

                <div class="cc-subscribe-form__wrapper">

                    <form class="cc-subscribe-form__form" id="subscribe-form" novalidate>

                        <input type="email" name="email" placeholder="Enter your email address" maxlength="80" required />

                        <button id="subscribe-button" class="cc-subscribe-form__button" type="submit" title="Sign Up">SIGN UP</button>
                    
                    </form>
                </div>
                <div class="cc-subscribe-form__message"></div>

            </div>

        `;

    }
       
  }

);